import { StandardButton } from '@/components/buttons';
import { useLayoutContext } from '@/contexts';
import { Flex, Input, Title } from '@mantine/core';
import { IconArrowLeft } from '@tabler/icons-react';
import { useState } from 'react';
import { useBagScanContext } from '../hook';
import styles from '../styles.module.css';

export const BagScanManualCodeEntryPage = () => {
	const { handleScan, setPage } = useBagScanContext();
	const [inputValue, setInputValue] = useState('');
	const { isDesktop } = useLayoutContext();

	return (
		<Flex
			pos="absolute"
			justify="center"
			h="100vh"
			pt="100px"
			w="100%"
			bg="var(--mantine-color-green-0)"
		>
			<Flex
				className={styles.manualEntryHeader}
				pos="fixed"
				top={isDesktop ? 69 : 0}
				left={0}
				p="md"
				bg="white"
				w="100%"
				align="center"
				gap="sm"
			>
				<IconArrowLeft onClick={() => setPage('SCAN')} />
				<Title order={2}>Enter Code Manually</Title>
			</Flex>
			<Flex px="lg" pt="xl" w="100%" maw={700} mx="auto" direction="column" gap="lg">
				<Input
					value={inputValue}
					onChange={(e) => setInputValue(e.target.value)}
					size={isDesktop ? 'md' : 'lg'}
					w="100%"
					placeholder="Enter Code"
				/>
				<StandardButton onClick={() => handleScan(inputValue)} variant="filled">
					Enter
				</StandardButton>
			</Flex>
		</Flex>
	);
};
